"use client";
import * as React from "react";
const SvgMailSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M16 .5H0v13h16zm-1.6 3.25L8 7.81 1.6 3.75V2.13L8 6.19l6.4-4.07z" }));
export {
  SvgMailSharp as default
};
